export { default } from './SectionTakeaways';